// Centralized social links — update once, everywhere is updated.
export const SOCIAL = {
    facebook: "https://www.facebook.com/61590396929846/",
};
